// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__AYwQT","activeUp":"styles_activeUp__2s6Pm","activeDown":"styles_activeDown__2xDDW"};